const CopyRightInfo = () => {
    return (
        <>
            <p className="mb-0 d-flex justify-content-center text-center">© 2025 Lambdanest Solutions LLP. All rights reserved.</p>
        </>
    )
}

export default CopyRightInfo